import { render, staticRenderFns } from "./Func18RevistasManuais.vue?vue&type=template&id=f7caacf6"
import script from "./Func18RevistasManuais.vue?vue&type=script&lang=js"
export * from "./Func18RevistasManuais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports